import { useQuery } from '@tanstack/react-query';
import { ChangeEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { getLocal } from 'api/adminApi';
import { getDelegateCount } from 'api/delegateApi';
import { delegateKeys, localKeys } from 'api/quires/queryKeys';
import DelegateModal from 'components/delegate/DelegateModal';
import { useRecoilState } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { isSuperAdmin } from 'util/commonUtil';
import { decryptId, decryptString } from 'util/encryptUtil';

import Image from 'components/widget/Image';
import HeaderNavList from './HeaderNavList';
import pen from './pen.svg';

type HeaderInfoProps = {
  onClick: () => void;
};

export default function HeaderInfo({ onClick }: HeaderInfoProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [userInfo, setUserInfo] = useRecoilState(userInfoState);
  const role = decryptString(userInfo.role);
  const isSuper = isSuperAdmin(role, decryptId(userInfo.factoryId));

  const { data: localData } = useQuery(localKeys.all, getLocal, {
    enabled: isSuper,
  });

  const { data: delegateCountResp, refetch: refetchDelegateCount } = useQuery({
    queryKey: delegateKeys.count(pathname),
    queryFn: getDelegateCount,
  });

  useEffect(() => {
    if (!localData || !localData.list) {
      return;
    }

    const local = userInfo.local ? userInfo.local : localData.list[0].id ?? '';
    if (local) {
      setUserInfo((prev) => ({ ...prev, local: local.toString() }));
    }
  }, [localData]);

  const onChangeFactoryCode = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    setUserInfo((prev) => ({ ...prev, factoryCode: value }));
  };

  const onChangeLocal = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    setUserInfo((prev) => ({ ...prev, local: value }));
  };

  const [isDelegateOpen, setIsDelegateOpen] = useState<boolean>(false);
  const onOpenDeleGateModal = () => {
    setIsDelegateOpen(true);
  };

  const onCloseDelegateModal = () => {
    setIsDelegateOpen(false);
  };

  const refreshDelegateCount = () => {
    refetchDelegateCount();
  };

  return (
    <>
      <div id={'header'}>
        <div id={'logo'}>
          <Link to={'/home/status-board'}>{'LOTO'}</Link>
        </div>
        <div className={'gnb-wrap'}>
          <HeaderNavList />
        </div>
        <div className={'account-wrap'}>
          {!isSuper && (
            <>
              <p className={'delegate-text'} onClick={onOpenDeleGateModal}>
                {t('coop.delegate')}
                &nbsp;
                {`${delegateCountResp?.delegateCount ?? 0}${t(
                  'conclusion.thing',
                )}`}
              </p>
              <p className={'delegate-text'} onClick={onOpenDeleGateModal}>
                {t('coop.mandate')}
                &nbsp;
                {`${delegateCountResp?.acceptCount ?? 0}${t(
                  'conclusion.thing',
                )}`}
              </p>
            </>
          )}

          {isSuper && (
            <div className={'select-wrap'}>
              <select
                className={'factoryCode-wrap'}
                value={userInfo?.local}
                onChange={onChangeLocal}
              >
                {localData?.list?.map((local) => (
                  <option value={local.id} key={`${local.id} ${local.code}`}>
                    {local.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {/* <div className={'select-wrap'}>
            <select
              className={'factoryCode-wrap'}
              value={userInfo?.factoryCode}
              onChange={onChangeFactoryCode}
            >
              <option value={'ALL'}>{t('orderManagement.all')}</option>
              {factoryCodeResp?.list?.map((facCode) => (
                <option value={facCode.codeName} key={facCode.factoryCode}>
                  {facCode.codeName}
                </option>
              ))}
            </select>
          </div> */}
          <p className={'membername'}>
            <span className={'grade'} />
            <Link to={'mypage'}>
              {`${userInfo?.name} ${t('home.sir')}`}
              &nbsp;
              <Image
                src={pen}
                alt={'mypage'}
                width={20}
                height={20}
                className={'img-top'}
              />
            </Link>
          </p>
          <button type={'button'} className={'btn-login'} onClick={onClick}>
            {t(`button.logout`)}
          </button>
        </div>
      </div>
      {isDelegateOpen && (
        <DelegateModal
          role={role}
          isOpen={isDelegateOpen}
          refreshDelegateCount={refreshDelegateCount}
          onClose={onCloseDelegateModal}
        />
      )}
    </>
  );
}
